(function () {
  'use strict';

  if (window.__quickAddCardInit) return;
  window.__quickAddCardInit = true;

  /**
   * Quick Add Card — add to cart handler.
   * Delegates to any button with [data-quick-add-variant] inside
   * .component-quick-add-card elements. Uses the same cart:update
   * event pattern as cart-drawer-recommendations.js.
   */

  document.addEventListener('click', async function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const button = /** @type {HTMLButtonElement|null} */ (target?.closest('[data-quick-add-variant]'));
    if (!button) return;

    const variantId = Number(button.dataset.quickAddVariant);
    if (!variantId) return;

    if (button.disabled) return;
    event.preventDefault();

    const originalLabel = button.querySelector('.component-quick-add-card__button-label')?.textContent || 'add';
    const labelEl = button.querySelector('.component-quick-add-card__button-label');

    button.disabled = true;
    if (labelEl) labelEl.textContent = '...';

    try {
      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('add-failed');

      const data = await response.json();

      // Refresh cart count
      let itemCount = data.item_count;
      if (typeof itemCount !== 'number') {
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (cartRes.ok) {
          const cart = await cartRes.json();
          itemCount = cart.item_count;
        }
      }

      // Notify cart drawer / cart icon — same pattern as cart-drawer-recommendations.js
      const cartEvent = new Event('cart:update', { bubbles: true });
      // @ts-ignore
      cartEvent.detail = {
        resource: data,
        sourceId: 'component-quick-add-card',
        data: {
          source: 'component-quick-add-card',
          itemCount: itemCount || 0,
          sections: data.sections,
        },
      };
      document.dispatchEvent(cartEvent);

      if (labelEl) labelEl.textContent = '✓';
      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalLabel;
      }, 1200);
    } catch (_) {
      if (labelEl) labelEl.textContent = originalLabel;
    } finally {
      button.disabled = false;
    }
  });
})();
